(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("icons/iconsV2", [], factory);
	else if(typeof exports === 'object')
		exports["icons/iconsV2"] = factory();
	else
		root["Survey"] = factory();
})(this, () => {
return 